__turbopack_context__.v({
  "eventInfo": "styles-module__aMrS5q__eventInfo",
  "eventInfoContent": "styles-module__aMrS5q__eventInfoContent",
  "eventInfoRaw": "styles-module__aMrS5q__eventInfoRaw",
  "eventRow": "styles-module__aMrS5q__eventRow",
  "eventRowButton": "styles-module__aMrS5q__eventRowButton",
  "grid": "styles-module__aMrS5q__grid",
  "listenerText": "styles-module__aMrS5q__listenerText",
  "spinner": "styles-module__aMrS5q__spinner",
});
